import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "cards-inventaire__info" }
const _hoisted_5 = {
  key: 0,
  class: "cards-inventaire__instavid__badgefocus360"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "cards-inventaire__brand" }
const _hoisted_8 = { class: "cards-inventaire__catego" }
const _hoisted_9 = { class: "cards-inventaire__info-content" }
const _hoisted_10 = { class: "cards-inventaire__bottom" }
const _hoisted_11 = { class: "cards-inventaire__row" }
const _hoisted_12 = {
  key: 0,
  class: "cards-inventaire__col"
}
const _hoisted_13 = { class: "cards-inventaire__detail" }
const _hoisted_14 = ["name"]
const _hoisted_15 = {
  key: 1,
  class: "cards-inventaire__col"
}
const _hoisted_16 = { class: "cards-inventaire__detail" }
const _hoisted_17 = ["name"]
const _hoisted_18 = ["name"]
const _hoisted_19 = {
  key: 2,
  class: "cards-inventaire__col cards-inventaire__col-end"
}
const _hoisted_20 = { class: "cards-inventaire__detail" }
const _hoisted_21 = { class: "cards-inventaire__row cards-inventaire__row-base" }
const _hoisted_22 = ["name"]
const _hoisted_23 = { class: "cards-inventaire__detail cards-inventaire__detail-light" }
const _hoisted_24 = { class: "cards-inventaire__mois" }
const _hoisted_25 = { class: "cards-inventaire__bottom" }
const _hoisted_26 = { class: "cards-inventaire__row" }
const _hoisted_27 = ["href"]
const _hoisted_28 = { class: "cards-inventaire__rapport-carfax" }
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "cards-inventaire__line" }, null, -1)
const _hoisted_31 = { class: "cards-inventaire__footer" }
const _hoisted_32 = { class: "cards-inventaire__footer__odo" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: "/wp-content/themes/theme_central/img/icone_cards_speed.svg",
  alt: "KM"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass([_ctx.state.switchDisplay ? 'cards-inventaire cards-inventaire__container' : 'cards-inventaire cards-inventaire__container cards-inventaire__container-list', _ctx.instavid ? 'cards-inventaire__instavid' : '']),
    href: _ctx.url+'/'+_ctx.route+'/'+_ctx.stringify+'/'+_ctx.id
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.state.switchDisplay ? 'cards-inventaire__header' : 'cards-inventaire__header cards-inventaire__header-list'])
    }, [
      _createElementVNode("img", {
        src: _ctx.imageLink,
        alt: _ctx.altTag,
        onError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imageLink=_ctx.defaultImg))
      }, null, 40, _hoisted_2),
      (_ctx.instavid)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: _normalizeClass(["cards-inventaire__instavid__badge360", _ctx.bg_instavid_class]),
            src: _ctx.instavidBackgoundImg,
            alt: "Instavid360"
          }, null, 10, _hoisted_3))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.state.switchDisplay ? 'cards-inventaire__content' : 'cards-inventaire__content cards-inventaire__content-list'])
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["cards-inventaire__ess", _ctx.bg_green_class])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.fuel), 1)
        ], 2),
        (_ctx.instavid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("img", { src: _ctx.instavidLogoImg }, null, 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", null, _toDisplayString(_ctx.brand) + " " + _toDisplayString(_ctx.model) + " " + _toDisplayString(_ctx.year), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", null, _toDisplayString(_ctx.category), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.discount == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.state.jsonFile['vehicule']['prixDetaillant']), 1)
                  ]),
                  _createElementVNode("div", {
                    name: _ctx.state.jsonFile['filtre']['price'],
                    class: "cards-inventaire__price"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.state.jsonFile['format']['money'].toString().replace('%value%', Number(_ctx.price).toLocaleString(_ctx.state.jsonFile['format']['locale']))), 1)
                  ], 8, _hoisted_14)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.state.jsonFile['vehicule']['prixDetaillant']), 1)
                  ]),
                  _createElementVNode("div", {
                    name: _ctx.state.jsonFile['filtre']['price'],
                    class: "cards-inventaire__price cards-inventaire__price-old"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.state.jsonFile['format']['money'].toString().replace('%value%', Number(_ctx.price + _ctx.discount).toLocaleString(_ctx.state.jsonFile['format']['locale']))), 1)
                  ], 8, _hoisted_17),
                  _createElementVNode("div", {
                    name: _ctx.state.jsonFile['filtre']['price'],
                    class: "cards-inventaire__price cards-inventaire__price-new"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.state.jsonFile['format']['money'].toString().replace('%value%', Number(_ctx.price).toLocaleString(_ctx.state.jsonFile['format']['locale']))), 1)
                  ], 8, _hoisted_18)
                ])),
            (typeof _ctx.financement !== 'undefined' && _ctx.financement[0] == 'true')
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.state.jsonFile['vehicule']['financement']['approximatif']), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", {
                      name: _ctx.state.jsonFile['filtre']['price'],
                      class: "cards-inventaire__price cards-inventaire__price-little"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.jsonFile['format']['money'].toString().replace('%value%', Number(_ctx.financement[3]).toLocaleString(_ctx.state.jsonFile['format']['locale']))), 1)
                    ], 8, _hoisted_22),
                    _createElementVNode("div", _hoisted_23, " /" + _toDisplayString(_ctx.state.jsonFile['vehicule']['financement']['week']), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.financement[1]) + _toDisplayString(_ctx.state.jsonFile['vehicule']['financement']['for']) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.financement[2]), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.jsonFile['vehicule']['financement']['month']), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", {
              class: _normalizeClass([ _ctx.type == 1 ? 'cards-inventaire__col' : 'cards-inventaire__col cards-inventaire__col-invisible'])
            }, [
              _createElementVNode("a", {
                href: _ctx.url+'/'+_ctx.route+'/'+_ctx.stringify+'/'+_ctx.id+'#description'
              }, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("img", {
                    src: _ctx.carfaxLink,
                    alt: "Carfax Canada",
                    onError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.carfaxLink='/wp-content/themes/theme_central/img/cfc_logo.svg'))
                  }, null, 40, _hoisted_29),
                  _createElementVNode("a", null, _toDisplayString(_ctx.state.jsonFile['action']['viewReport']), 1)
                ])
              ], 8, _hoisted_27)
            ], 2)
          ]),
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("span", null, _toDisplayString(_ctx.traction), 1),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("span", null, _toDisplayString(_ctx.state.jsonFile['format']['distance'].toString().replace('%value%', Number(_ctx.odo).toLocaleString(_ctx.state.jsonFile['format']['locale']))), 1)
            ])
          ])
        ])
      ])
    ], 2)
  ], 10, _hoisted_1))
}